// AskIAM UI Theme - Layout Constants

export const layout = {
  sidebarWidth: 260,
  sidebarCollapsedWidth: 64,
  // Kept in sync with the theme.mixins.toolbar override in theme.ts, which is
  // the value MUI's AppBar/Toolbar and GuestDetailPanel's drawer-offset
  // calculation actually read at runtime - this constant is for callers that
  // need the number directly (e.g. HomePage's viewport-height calc).
  headerHeight: 48,
  contentPadding: '2rem',
  borderRadius: {
    small: 4,
    medium: 8,
  },
  shadow: {
    card: '0 2px 4px rgba(0, 0, 0, 0.1)',
    dropdown: '0 2px 8px rgba(0, 0, 0, 0.15)',
  },
} as const;
